<template>
    <div>
        <loading :show="isLoading"></loading>
        <modal-confirm :show="showConfirm" @onselect="onConfirmSelection">
            <h4>{{confirmMsg}}</h4>
        </modal-confirm>
        <div style="width:100%;padding:5px;">
            <span class="btn btn-default" @click="loadItem">{{lang.common.refresh}}</span>
        </div>

        <div>
            <div class="panel panel-default">

                <div class="panel-body" v-if="item!==null">

                    <div>
                        <h4>{{item.shop.shopName}} </h4>
                        <div class="col-xs-12">
                            <span style="font-weight:bold;"> {{lang.order.orderNum}}: {{item.id}} </span>
                            <span style="color:gray;"> Date: {{item.localCreateDate}} </span>
                        </div>


                        <div style="font-size:1.5em;width:100%;text-align:right;">
                            <div class="label label-info"> {{lang.stateLabels.order[item.stateCode]}}</div>
                        </div>



                        <div>

                            <div v-for="(orderItem,index) in item.items" class="act-order-item row" :order-id="orderItem.id" style="border-bottom:1px solid gray;">
                                <div class="col-xs-12"><span style="font-weight:bold;">{{index+1}}</span> <span style="color:#808080;font-size:10px;padding:4px;">REF{{orderItem.id}}</span> </div>
                                <div class="col-xs-2">
                                    <img class="img-responsive" style="display:inline-block;max-height:100px;"
                                         :src="orderItem.post.thumbPath">
                                </div>
                                <div class="col-xs-6">
                                    {{orderItem.title}}
                                    <br>
                                    <div v-for="pc in orderItem.propCats">
                                        {{pc.parent.name}}:{{pc.child.name}}
                                    </div>
                                </div>
                                <div class="col-xs-2">{{orderItem.price}} x {{orderItem.quant}}</div>
                                <div class="col-xs-2"> {{orderItem.subTotal}} </div>
                            </div>

                            <div class="row" v-for="(extraItem,index) in item.orderExtras">
                                <div class="col-xs-6"></div>
                                <div class="col-xs-4">{{extraItem.child.name}}</div>
                                <div class="col-xs-2">{{extraItem.label.amount}}</div>
                            </div>

                            <div class="row">
                                <div class="col-xs-6"></div>
                                <div class="col-xs-6"> 
                                    <div style="text-align:center;">
                                        <span>{{lang.order.total}}({{currency}}):</span>
                                        <span v-if="isTotalReady">{{item.orderTotal}}</span>
                                        <span class="label label-warning" v-else>{{lang.stateLabels.order[item.stateCode]}}</span>
                                    </div>
                                </div>
                            </div>
                            <div>{{lang.order.buyerMsg}}: {{item.userMsg}}</div>
                            <div>{{lang.order.shopMsg}}: <span style="color:red;"> {{item.shopMsg}} </span></div>
                            <div>


                                <div>
                                    <span style="font-weight:bold;">{{lang.common.name}}:</span>{{item.contact.name}} /
                                    <span style="font-weight:bold;">{{lang.common.phone}}:</span>{{item.contact.phone}}
                                    <div>
                                        <div style="font-weight:bold;">{{lang.contact.deliveryAddress}}:</div>
                                        <div>{{item.contact.address}}</div>
                                    </div>
                                    <div v-if="item.contact.pickContact!==null" style="padding-left:16px;">
                                        <div class="label label-info"> {{lang.common.pickup}} </div>
                                        <div>{{item.contact.pickContact.title}}:{{item.contact.pickContact.phone}}</div>
                                        <div>{{item.contact.pickContact.address}}</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div v-if="orderPayable">
                        <div class="row">
                            <div class="col-xs-12">
                                <h3>{{lang.order.payMethods}}</h3>
                            </div>
                        </div>
                        <div class="row" style="text-align:center;">
                            <div class="col-xs-12 col-sm-6 col-md-4" v-if="payPalEnabled">
                                <div class="payment-option">
                                    <div class="payment-info">{{paypalAccount.info}}</div>
                                    <div class="payment-account">{{paypalAccount.accountNo}}</div>
                                    <span id="paypal-button-container"></span>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-6 col-md-4" v-if="payCashEnabled">
                                <div class="payment-option">
                                    <div class="payment-info">{{cashAccount.info}}</div>
                                    <div class="payment-account">{{cashAccount.accountNo}}</div>
                                    <span @click="setCashPayment" class="btn btn-info">
                                        {{lang.order.cashOnDelivery}}
                                    </span>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-6 col-md-4" v-if="payFpsEnabled">
                                <div class="payment-option">
                                    <div class="payment-info">{{fpsAccount.info}}</div>
                                    <div class="payment-account">{{fpsAccount.accountNo}}</div>
                                    <span @click="setFpsPayment" class="btn btn-info">
                                        {{lang.order.payByFps}}
                                    </span>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-6 col-md-4" v-if="payMeEnabled">
                                <div class="payment-option">
                                    <div class="payment-info">{{payMeAccount.info}}</div>
                                    <div class="payment-account">{{payMeAccount.accountNo}}</div>
                                    <span @click="setPayMePayment" class="btn btn-info">
                                        {{lang.order.payByPayMe}}
                                    </span>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-6 col-md-4" v-if="payWechatEnabled">
                                <div class="payment-option">
                                    <div class="payment-info">{{wechatpayAccount.info}}</div>
                                    <div class="payment-account">{{wechatpayAccount.accountNo}}</div>
                                    <span @click="setWechatpayPayment" class="btn btn-info">
                                        {{lang.order.payByWechatpay}}
                                    </span>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-6 col-md-4" v-if="payAliEnabled">
                                <div class="payment-option">
                                    <div class="payment-info">{{alipayAccount.info}}</div>
                                    <div class="payment-account">{{alipayAccount.accountNo}}</div>
                                    <span @click="setAlipayPayment" class="btn btn-info">
                                        {{lang.order.payByAlipay}}
                                    </span>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-6 col-md-4" v-if="payAtmEnabled">
                                <div class="payment-option">
                                    <div class="payment-info">{{atmAccount.info}}</div>
                                    <div class="payment-account">{{atmAccount.accountNo}}</div>
                                    <span @click="setAtmPayment" class="btn btn-info">
                                        {{lang.order.payByAtm}}
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div v-if="paymentSelected!==null && !orderPayable" class="col-xs-12" style="text-align: center;">
                        <div class="payment-option">
                            <h3>{{lang.order.selectedPayment}}</h3>
                            <div class="payment-info">{{paymentSelected.account.info}}</div>
                            <div class="payment-account">{{paymentSelected.account.accountNo}}</div>
                            <div style="font-size:1.5em;width:100%;">
                                <div class="label label-info"> {{lang.stateLabels.order[item.stateCode]}}</div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import modalConfirm from './base/ModalConfirm.vue';
    import loading from './base/Loading.vue';
    export default {
        components: {
            modalConfirm: modalConfirm,
            loading: loading
        },
        props: ["orderId"],
        data: function () {
            return {
                item: null,
                confirmMsg: null,
                showConfirm: false,
                isLoading: false
            };
        },
        computed: {
            apiClient: function () {
                return this.mxnAgxApi.orderDetailApiClient;
            },
            orderPayable: function () {
                return this.item !== null && this.item.stateCode === this.apiClient.orderStateCodes.offerReady;
            },
            isTotalReady: function () {
                return this.item !== null && this.item.stateCode !== this.apiClient.orderStateCodes.active;
            },
            lang: function () {
                return this.$store.getters.lang;
            },
            currency: function () {
                return this.$store.getters.configs.currency;
            },
            payPalEnabled: function () {
                return this.shopConfigs.payPalEnabled;
            },
            payCashEnabled: function () {
                return this.shopConfigs.payCashEnabled;
            },
            payFpsEnabled: function () {
                return this.shopConfigs.payFpsEnabled;
            },
            payAliEnabled: function () {
                return this.shopConfigs.payAliEnabled;
            },
            payWechatEnabled: function () {
                return this.shopConfigs.payWechatEnabled;
            },
            payAtmEnabled: function () {
                return this.shopConfigs.payAtmEnabled;
            },
            shopConfigs: function () {
                return this.$store.getters.shopConfigs;
            },
            cashAccount: function () {
                return this.$store.getters.configs.cashAccount;
            },
            atmAccount: function () {
                return this.$store.getters.configs.atmAccount;
            },
            fpsAccount: function () {
                return this.$store.getters.configs.fpsAccount;
            },
            payMeAccount: function () {
                return this.$store.getters.configs.payMeAccount;
            },
            paypalAccount: function () {
                return this.$store.getters.configs.paypalAccount;
            },
            alipayAccount: function () {
                return this.$store.getters.configs.alipayAccount;
            },
            wechatpayAccount: function () {
                return this.$store.getters.configs.wechatpayAccount;
            },
            paymentSelected: function () {
                if (this.item.payments.length === 0) return null;
                var payment = this.item.payments[0];
                var ret = { payment };
                if (payment.method === 'cash') {
                    ret.account = this.cashAccount;
                    return ret;
                }

                if (payment.method === 'atm') {
                    ret.account = this.atmAccount;
                    return ret;
                }

                if (payment.method === 'fps') {
                    ret.account = this.fpsAccount;
                    return ret;
                }

                if (payment.method === 'payme') {
                    ret.account = this.payMeAccount;
                    return ret;
                }

                if (payment.method === 'paypal') {
                    ret.account = this.paypalAccount;
                    return ret;
                }

                if (payment.method === 'wechatpay') {
                    ret.account = this.wechatpayAccount;
                    return ret;
                }

                if (payment.method === 'alipay') {
                    ret.account = this.alipayAccount;
                    return ret;
                }

                return ret;

            }
        },
        methods: {
            confirmListener: function () { },
            onConfirmSelection: function (positive) {
                this.confirmListener(positive);
            },
            loadItem: function () {
                var $that = this;
                this.item = null;
                this.apiClient.getOrderDetailPrms($that.orderId).done(function (data) {
                    $that.item = null;
                    if (data !== null) {
                        $that.item = data.item;
                        $that.$nextTick(() => {
                            if (data.item.stateCode === $that.apiClient.orderStateCodes.offerReady) {
                                $that.apiClient.loadPaypalPrms().done(function () {
                                    $that.renderPaypalBtn(data.item.id, data.paypalEnvironment);
                                });
                            }
                        });
                    }
                });
            },
            setCashPayment: function () {
                this.setManualPayment("cash", this.lang.order.cashOnDelivery);
            },
            setAtmPayment: function () {
                this.setManualPayment("atm", this.lang.order.payByAtm);
            },
            setFpsPayment: function () {
                this.setManualPayment("fps", this.lang.order.payByFps);
            },
            setPayMePayment: function () {
                this.setManualPayment("payme", this.lang.order.payByPayMe);
            },
            setAlipayPayment: function () {
                this.setManualPayment("alipay", this.lang.order.payByAlipay);
            },
            setWechatpayPayment: function () {
                this.setManualPayment("wechatpay", this.lang.order.payByWechatpay);
            },
            setManualPayment: function (payMethod, payMethodDisplayName) {
                this.confirmListener = (positive) => {
                    this.showConfirm = false;
                    if (positive === true) {
                        this.isLoading = true;//need to handle the case on 401 to stop loading
                        var orderId = this.item.id;
                        this.apiClient.setManualPaymentPrms({ orderId: orderId, method: payMethod }).then((ret) => {
                            this.isLoading = false;
                            this.loadItem();
                        }).fail(() => {
                            this.isLoading = false;
                            alert('fail setPayment');
                        });
                    }
                };
                this.confirmMsg = this.lang.common.confirm + " " + payMethodDisplayName + "?";
                this.showConfirm = true;
            },
            renderPaypalBtn: function (orderId, environment) {
                var _orderPaymentId = null;
                var $that = this;
                paypal.Button.render({
                    env: environment, /* sandbox | production */
                    /* Show the buyer a 'Pay Now' button in the checkout flow */
                    commit: true,
                    /* payment() is called when the button is clicked */
                    payment: function () {
                        /* Set up a url on your server to create the payment */
                        return apiClient.createPaypalPaymentPrms({ orderId: orderId }).then(function (data) {
                            _orderPaymentId = data.orderPaymentId;
                            return data.paymentId;
                        });
                    },
                    /* onAuthorize() is called when the buyer approves the payment */
                    onAuthorize: function (data, actions) {
                        /* Set up the data you need to pass to your server */
                        var payload = {
                            intent: data.intent,
                            orderId: data.orderID,
                            payerId: data.payerID,
                            paymentId: data.paymentID,
                            paymentToken: data.paymentToken,
                            orderPaymentId: _orderPaymentId
                        };
                        /* Make a call to your server to execute the payment */
                        return apiClient.executePaypalPaymentPrms(payload).then(function (res) {
                            if (res.responseText === "ok") {
                                $that.loadItem();
                            }
                        });

                    }
                }, '#paypal-button-container');
            }
        },
        created: function () {
            this.apiClient.onLoginApi.on(this.loadItem);
            this.loadItem();
        },
        destroyed: function () {
            this.apiClient.onLoginApi.remove(this.loadItem);
        }
    }
</script>